import { render, staticRenderFns } from "./AdvertGenerationModal.vue?vue&type=template&id=3c38b204&scoped=true"
import script from "./AdvertGenerationModal.vue?vue&type=script&lang=ts"
export * from "./AdvertGenerationModal.vue?vue&type=script&lang=ts"
import style0 from "./AdvertGenerationModal.vue?vue&type=style&index=0&id=3c38b204&prod&lang=scss&scoped=true"
import style1 from "./AdvertGenerationModal.vue?vue&type=style&index=1&id=3c38b204&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c38b204",
  null
  
)

export default component.exports